var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSongListIcon = function SvgSongListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 6.667a1.333 1.333 0 0 0 0 2.667h14.667a1.333 1.333 0 1 0 0-2.667zm20 0c-.736 0-1.333.597-1.333 1.333v12.228A4 4 0 1 0 25.334 24V9.334H28a1.333 1.333 0 1 0 0-2.667zM2.667 16c0-.736.597-1.333 1.333-1.333h14.667a1.333 1.333 0 1 1 0 2.667H4A1.333 1.333 0 0 1 2.667 16M4 22.667a1.333 1.333 0 1 0 0 2.667h9.333a1.333 1.333 0 0 0 0-2.667z"
  })));
};
export default SvgSongListIcon;